module.exports = __webpack_public_path__ + "img/product6.fc6df8cf.png";